import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TYTCommonModule } from '@tytapp/common';
import { CommonUiModule } from '@tytapp/common-ui';
import { MediaPlaybackModule } from '@tytapp/media-playback';
import { ProductionCalendarComponent } from './production-calendar/production-calendar.component';

@NgModule({
    declarations: [
        ProductionCalendarComponent
    ],
    imports: [
        CommonModule,
        TYTCommonModule,
        CommonUiModule,
        MatIconModule,
        MatButtonModule,
        MediaPlaybackModule,
        RouterModule.forChild([
            { path: 'search', loadChildren: () => import('../../pages/search-pages').then(m => m.SearchPagesModule) },
            { path: '', component: ProductionCalendarComponent, pathMatch: 'full' },
            { path: ':date', component: ProductionCalendarComponent },
        ])
    ]
})
export class ArchivePagesModule {

}